export default {
  'app.title': 'RoyalSKM Admin',
};

